angular.module('bizmetryApp').controller('TableMapperDialogController', function (
    $scope, $mdDialog, $mdToast, $timeout,
    DatasourceService,
    templateInstance, resourceTypeId, datasourceId, datasourceName, schema, tableName,
    mode, dialogService
) {
    console.log('🗺️ Map Columns Dialog opened');
    console.log('  📋 Template Instance:', templateInstance);
    console.log('  📦 Resource Type ID:', resourceTypeId);
    console.log('  💾 Datasource ID:', datasourceId);
    console.log('  📁 DataSource Name:', datasourceName);
    console.log('  📁 Schema:', schema);
    console.log('  📊 Table:', tableName);
    console.log('  🔧 Mode:', mode || 'create');

    // ============================================
    // Inicialización
    // ============================================
    $scope.loading = true;
    $scope.tableName = tableName;
    $scope.schemaName = schema;
    $scope.datasourceName = datasourceName;
    $scope.resourceTypeName = '';
    $scope.mode = mode || 'create';

    // Columnas de la tabla (lado izquierdo)
    $scope.tableColumns = [];

    // Atributos del resource (lado derecho)
    $scope.resourceAttributes = [];

    // Mapeos: [{ attributeName, attributeId, columnName, isTypeCompatible, suggestedType }]
    $scope.mappings = [];

    // ✅ Estado inicial de mappings (para detectar cambios en modo EDIT)
    $scope.initialMappings = [];

    // ── Wire-drag state (mousedown/mousemove/mouseup live-wire system) ─────
    $scope.connecting = null;              // { column, startX, startY } while dragging
    $scope.connectingTarget = null;        // attribute currently under cursor
    $scope.connectingValid = null;         // true/false/null — target validity
    $scope.connectingDropZoneIndex = null; // hovered gap index, or null
    $scope._liveWire = null;               // { d, x1, y1, x2, y2, snapped, invalid }
    $scope._connectingInvalidMap = {};     // { attributeId: true } — precomputed per drag
    $scope._connectors = [];               // [{id, d, x1,y1,x2,y2,cx,cy, isTypeCompatible}]
    $scope._focusedConnId = null;          // hover-focus id for permanent connectors

    $scope.newAttributeIdCounter = 1000;

    // ── Search (UI-only — filters nothing, just highlights + scrolls) ──────
    // NOTE: kept on an object (not bare $scope.columnSearchTerm string
    // primitives) on purpose. <md-dialog-content ng-if="!loading"> creates a
    // child scope for the whole panel; ng-model on a primitive there would
    // shadow the write on that child scope instead of updating this scope,
    // so the $watch/isXSearchMatch below (closured over this $scope) would
    // never see it. An object reference is shared, not shadowed.
    $scope.search = { column: '', attribute: '' };
    $scope.$watch('search.column', function (n, o) {
        console.log('[DEBUG-SEARCH] search.column watch fired:', JSON.stringify(o), '->', JSON.stringify(n));
        // Filtering toggles ng-hide on column-items, which moves/collapses
        // attribute rows too (they reflow to fill the gap) — connectors need
        // a redraw once that reflow has actually painted, not just on the
        // next scroll event.
        $timeout(recalcConnectors, 50);
    });
    $scope.$watch('search.attribute', function (n, o) {
        console.log('[DEBUG-SEARCH] search.attribute watch fired:', JSON.stringify(o), '->', JSON.stringify(n));
        $timeout(recalcConnectors, 50);
    });

    // ============================================
    // Type Compatibility Map
    // ============================================
    // ============================================
    // Type Compatibility Map
    // ============================================
    const typeCompatibilityMap = {
        'STRING': ['VARCHAR', 'CHAR', 'TEXT', 'STRING', 'NVARCHAR', 'NCHAR', 'CLOB', 'LONGTEXT', 'MEDIUMTEXT', 'TINYTEXT', 'SET', 'UUID', 'UNIQUEIDENTIFIER', 'CHARACTER', 'CHARACTER VARYING', 'BPCHAR', 'CITEXT', 'NAME', 'OBJECTID', 'NCLOB'],
        'INTEGER': ['INTEGER', 'INT', 'BIGINT', 'SMALLINT', 'TINYINT', 'NUMBER', 'NUMERIC'],
        'INT': ['INTEGER', 'INT', 'BIGINT', 'SMALLINT', 'TINYINT', 'NUMBER'],
        'LONG': ['BIGINT', 'LONG', 'INTEGER', 'INT', 'NUMBER'],
        'DECIMAL': ['DECIMAL', 'NUMERIC', 'FLOAT', 'DOUBLE', 'REAL', 'NUMBER', 'INTEGER', 'INT', 'BIGINT'],
        'FLOAT': ['FLOAT', 'DOUBLE', 'REAL', 'DECIMAL', 'NUMERIC', 'NUMBER'],
        'DOUBLE': ['DOUBLE', 'FLOAT', 'REAL', 'DECIMAL', 'NUMERIC', 'NUMBER'],
        'NUMBER': ['NUMBER', 'INTEGER', 'INT', 'BIGINT', 'DECIMAL', 'NUMERIC', 'FLOAT', 'DOUBLE'],
        'BOOLEAN': ['BOOLEAN', 'BOOL', 'BIT', 'TINYINT'],
        'DATE': ['DATE', 'DATETIME', 'TIMESTAMP', 'TIME'],
        'DATETIME': ['DATETIME', 'TIMESTAMP', 'DATE', 'TIME'],
        'TIMESTAMP': ['TIMESTAMP', 'TIMESTAMPTZ', 'DATETIME', 'DATE', 'TIME', 'TIMETZ'],
        'UUID': ['UUID', 'UNIQUEIDENTIFIER', 'CHAR', 'VARCHAR', 'STRING'],
        'BINARY': ['BINARY', 'VARBINARY', 'BLOB', 'BYTEA'],
        'JSON': ['JSON', 'JSONB', 'TEXT', 'CLOB', 'VARCHAR'],
        'ENUM': ['ENUM'],
        // ✅ VARIANT acepta CUALQUIER tipo de columna SQL
        'VARIANT': ['VARCHAR', 'CHAR', 'TEXT', 'STRING', 'NVARCHAR', 'NCHAR', 'CLOB', 'LONGTEXT', 'MEDIUMTEXT', 'TINYTEXT',
            'INTEGER', 'INT', 'BIGINT', 'SMALLINT', 'TINYINT', 'NUMBER',
            'DECIMAL', 'NUMERIC', 'FLOAT', 'DOUBLE', 'REAL',
            'BOOLEAN', 'BOOL', 'BIT',
            'DATE', 'DATETIME', 'TIMESTAMP', 'TIME',
            'UUID', 'UNIQUEIDENTIFIER',
            'BINARY', 'VARBINARY', 'BLOB', 'BYTEA',
            'JSON', 'JSONB', 'ENUM', 'SET']
    };

    // ============================================
    // Detect Changes in Mappings (for EDIT mode)
    // ============================================
    $scope.hasChanges = function () {
        if ($scope.mode !== 'edit') {
            return true; // En modo CREATE siempre permitir confirmar
        }

        // Comparar cantidad de mappings
        if ($scope.mappings.length !== $scope.initialMappings.length) {
            return true;
        }

        // Comparar cada mapping
        for (let i = 0; i < $scope.mappings.length; i++) {
            const current = $scope.mappings[i];
            const initial = $scope.initialMappings.find(m =>
                m.attributeId === current.attributeId &&
                m.columnName === current.columnName
            );

            if (!initial) {
                return true; // Mapping nuevo o cambiado
            }
        }

        return false; // No hay cambios
    };

    // ============================================
    // Check Type Compatibility
    // ============================================
    // ============================================
    // Check Type Compatibility
    // ============================================
    function areTypesCompatible(attributeType, columnType) {
        if (!attributeType || !columnType) {
            console.warn('⚠️ Type compatibility check with null/undefined:', { attributeType, columnType });
            return true;
        }

        // ✅ Normalize types: trim and uppercase
        const attrTypeUpper = attributeType.toString().trim().toUpperCase();
        const colTypeUpper = columnType.toString().trim().toUpperCase();

        console.log(`🔍 Checking compatibility: "${attrTypeUpper}" (attribute) vs "${colTypeUpper}" (column)`);

        // ✅ Si el ATRIBUTO es VARIANT → acepta CUALQUIER columna
        if (attrTypeUpper === 'VARIANT') {
            console.log('  ✅ Attribute is VARIANT - compatible with any column type');
            return true;
        }

        // ✅ Exact match
        if (attrTypeUpper === colTypeUpper) {
            console.log('  ✅ Exact match');
            return true;
        }

        // ✅ Get compatible types for this attribute type
        const compatibleTypes = typeCompatibilityMap[attrTypeUpper] || [];

        if (compatibleTypes.length === 0) {
            console.warn(`  ⚠️ No compatibility map found for attribute type: ${attrTypeUpper}`);
            return false;
        }

        console.log(`  📋 Compatible types for ${attrTypeUpper}:`, compatibleTypes);

        // ✅ Check if column type matches any compatible type
        const isCompatible = compatibleTypes.some(compatType => {
            const compatTypeUpper = compatType.toUpperCase();

            // Exact match
            if (colTypeUpper === compatTypeUpper) {
                console.log(`  ✅ Match found: ${colTypeUpper} === ${compatTypeUpper}`);
                return true;
            }

            // StartsWith match (for types like VARCHAR(255))
            if (colTypeUpper.startsWith(compatTypeUpper)) {
                console.log(`  ✅ StartsWith match: ${colTypeUpper} starts with ${compatTypeUpper}`);
                return true;
            }

            return false;
        });

        if (!isCompatible) {
            console.warn(`  ❌ No compatibility found for ${colTypeUpper} with ${attrTypeUpper}`);
        }

        return isCompatible;
    }

    // ============================================
    // Suggest Best Type for Column
    // ============================================
    // ============================================
    // Suggest Best Type for Column
    // ============================================
    function suggestTypeForColumn(columnType) {
        if (!columnType) {
            console.log('⚠️ suggestTypeForColumn called with empty columnType, defaulting to STRING');
            return 'STRING';
        }

        // ✅ Normalize: trim and uppercase
        const colTypeUpper = columnType.toString().trim().toUpperCase();

        console.log(`🔍 Suggesting type for column type: "${colTypeUpper}"`);

        // Every value here MUST be one of the backend's ScalarAttributeType
        // enum members (STRING, INTEGER, FLOAT, BOOLEAN, DATE, TIMESTAMP,
        // BINARY, JSON, VARIANT, ENUM — see bizmetry-core-ms
        // ScalarAttributeType.java). Suggesting anything else (e.g. the old
        // 'DECIMAL'/'DOUBLE'/'NUMBER'/'DATETIME'/'UUID'/'LONG') gets saved
        // as attribute.dataType with no server-side validation on that path,
        // and later blows up any strict TemplateConfig deserialization
        // (e.g. the resource-types import endpoint) with a Jackson enum
        // error. Mirrors ScalarAttributeType.fromDataType's own mapping.
        const typeSuggestions = {
            'VARCHAR': 'STRING',
            'CHAR': 'STRING',
            'TEXT': 'STRING',
            'NVARCHAR': 'STRING',
            'NCHAR': 'STRING',
            'CLOB': 'STRING',
            'LONGTEXT': 'STRING',
            'MEDIUMTEXT': 'STRING',
            'TINYTEXT': 'STRING',
            'STRING': 'STRING',
            'SET': 'STRING',
            'UUID': 'STRING',
            'UNIQUEIDENTIFIER': 'STRING',
            'ENUM': 'ENUM',
            'INTEGER': 'INTEGER',
            'INT': 'INTEGER',
            'BIGINT': 'INTEGER',
            'SMALLINT': 'INTEGER',
            'TINYINT': 'INTEGER',
            'NUMBER': 'INTEGER',
            'NUMERIC': 'INTEGER',
            'DECIMAL': 'FLOAT',
            'FLOAT': 'FLOAT',
            'DOUBLE': 'FLOAT',
            'REAL': 'FLOAT',
            'BOOLEAN': 'BOOLEAN',
            'BOOL': 'BOOLEAN',
            'BIT': 'BOOLEAN',
            'DATE': 'DATE',
            'DATETIME': 'TIMESTAMP',
            'TIMESTAMP': 'TIMESTAMP',
            'TIME': 'TIMESTAMP',
            'BINARY': 'BINARY',
            'VARBINARY': 'BINARY',
            'BLOB': 'BINARY',
            'BYTEA': 'BINARY',
            'JSON': 'JSON',
            'JSONB': 'JSON'
            // ❌ NO incluir VARIANT aquí - no es tipo SQL
        };

        for (const [sqlType, attrType] of Object.entries(typeSuggestions).sort((a, b) => b[0].length - a[0].length)) {
            if (colTypeUpper === sqlType || colTypeUpper.startsWith(sqlType)) {
                console.log(`  ✅ Suggestion: ${attrType} (matched ${sqlType})`);
                return attrType;
            }
        }

        console.log(`  ⚠️ No suggestion found for "${colTypeUpper}", defaulting to STRING`);
        return 'STRING';
    }
    // ============================================
    // Initialize Existing Mappings (EDIT mode)
    // ============================================
    function initializeExistingMappings() {
        console.log('📋 Initializing existing mappings (EDIT mode)...');
        console.log('📊 Total resource attributes:', $scope.resourceAttributes.length);
        console.log('📊 Total table columns:', $scope.tableColumns.length);

        let mappingsCreated = 0;
        let incompatibleMappings = 0;

        $scope.resourceAttributes.forEach(attr => {
            if (attr.columnMetadataName) {
                const columnName = attr.columnMetadataName;
                const column = $scope.tableColumns.find(col => col.columnName === columnName);

                console.log('');
                console.log(`🔍 Processing attribute: "${attr.name}"`);
                console.log(`   - Attribute Type (raw): "${attr.dataType}" (length: ${attr.dataType?.length})`);
                console.log(`   - Looking for column: "${columnName}"`);

                if (column) {
                    console.log(`   ✅ Column found: "${column.columnName}"`);
                    console.log(`   - Column Type (raw): "${column.dataType}" (length: ${column.dataType?.length})`);

                    // ⚠️ DEBUG: Mostrar bytes de los strings
                    const attrBytes = Array.from(attr.dataType || '').map(c => c.charCodeAt(0));
                    const colBytes = Array.from(column.dataType || '').map(c => c.charCodeAt(0));
                    console.log(`   - Attribute Type bytes: [${attrBytes.join(', ')}]`);
                    console.log(`   - Column Type bytes: [${colBytes.join(', ')}]`);

                    const isCompatible = areTypesCompatible(attr.dataType, column.dataType);
                    console.log(`   - Compatibility result: ${isCompatible}`);

                    const suggestedType = isCompatible ? null : suggestTypeForColumn(column.dataType);
                    if (suggestedType) {
                        console.log(`   - Suggested type: "${suggestedType}"`);
                    }

                    $scope.mappings.push({
                        attributeName: attr.name,
                        attributeId: attr.id,
                        columnName: column.columnName,
                        isTypeCompatible: isCompatible,
                        suggestedType: suggestedType
                    });

                    column.mapped = true;
                    column.mappedTo = attr.name;
                    attr.mapped = true;
                    attr.mappedFrom = column.columnName;

                    mappingsCreated++;

                    if (!isCompatible) {
                        incompatibleMappings++;
                        console.warn(`   ⚠️ INCOMPATIBLE MAPPING CREATED`);
                    } else {
                        console.log(`   ✅ Compatible mapping created`);
                    }
                } else {
                    console.warn(`⚠️ Column not found for attribute "${attr.name}": ${columnName}`);
                }
            }
        });

        console.log(`✅ Existing mappings initialized: ${mappingsCreated} total`);

        // ✅ Guardar snapshot del estado inicial para detectar cambios
        $scope.initialMappings = $scope.mappings.map(m => ({
            attributeId: m.attributeId,
            columnName: m.columnName
        }));

        console.log('📸 Initial mappings snapshot saved:', $scope.initialMappings.length);

        if (incompatibleMappings > 0) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(`⚠️ Loaded ${mappingsCreated} mappings (${incompatibleMappings} with type issues)`)
                    .position('top right')
                    .hideDelay(4000)
            );
        } else if (mappingsCreated > 0) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(`✅ Loaded ${mappingsCreated} existing mappings`)
                    .position('top right')
                    .hideDelay(3000)
            );
        }
    }

    // ============================================
    // ✅ Generar ID único para atributo
    // ============================================
    function generateNewAttributeId() {
        return crypto.randomUUID();
    }

    // ============================================
    // ✅ Verificar si existe atributo con el mismo nombre
    // ============================================
    function attributeNameExists(attributeName) {
        const normalized = attributeName.toLowerCase().trim();
        return $scope.resourceAttributes.some(attr =>
            attr.name.toLowerCase().trim() === normalized
        );
    }
    // ============================================
    // ✅ Crear atributo desde columna
    // ============================================
    // ============================================
    // ✅ Crear atributo desde columna
    // ============================================
    $scope.createAttributeFromColumn = function (column, insertIndex) {
        // ✅ NUEVO: Validar que no exista atributo con el mismo nombre
        if (attributeNameExists(column.columnName)) {
            console.warn(`⚠️ Cannot create attribute: "${column.columnName}" already exists`);
            $mdToast.show(
                $mdToast.simple()
                    .textContent(`Attribute "${column.columnName}" already exists`)
                    .position('top right')
                    .hideDelay(2500)
            );
            return null;
        }

        console.log(`✨ Creating new attribute from column: ${column.columnName} at index ${insertIndex}`);

        const suggestedType = suggestTypeForColumn(column.dataType);

        const newAttribute = {
            id: generateNewAttributeId(),
            name: column.columnName,
            dataType: suggestedType,
            originalDataType: null,
            isPrimaryKey: column.isPrimaryKey || false,
            isRequired: !column.isNullable,
            mapped: true,
            mappedFrom: column.columnName,
            typeChanged: false,
            isNewlyCreated: true,
            createdFromImport: true,
            description: column.description || null,
            enumValues: (suggestedType === 'ENUM' || suggestedType === 'SET') ?
                (column.enumValues || null) : null
        };

        $scope.resourceAttributes.splice(insertIndex, 0, newAttribute);
        // Re-sort so the list stays alphabetically ascending even after a
        // newly created attribute lands wherever the drop gesture indicated.
        sortByKeyAscending($scope.resourceAttributes, 'name');

        $scope.mappings.push({
            attributeName: newAttribute.name,
            attributeId: newAttribute.id,
            columnName: column.columnName,
            isTypeCompatible: true,
            suggestedType: null
        });

        column.mapped = true;
        column.mappedTo = newAttribute.name;

        console.log(`✅ New attribute created:`, newAttribute);

        $timeout(() => {
            newAttribute.isNewlyCreated = false;
        }, 3000);

        return newAttribute;
    };
    // ============================================
    // Change Attribute Type
    // ============================================
    $scope.changeAttributeType = function (attribute, newType) {
        if (!newType || String(attribute.dataType).trim().toUpperCase() === String(newType).trim().toUpperCase()) return;
        console.log(`🔄 Changing attribute type: ${attribute.name} from ${attribute.dataType} to ${newType}`);

        if (!attribute.typeChanged) {
            attribute.originalDataType = attribute.dataType;
        }

        attribute.dataType = newType;
        attribute.typeChanged = true;

        const mapping = $scope.mappings.find(m => m.attributeId === attribute.id);
        if (mapping) {
            const column = $scope.tableColumns.find(c => c.columnName === mapping.columnName);
            if (column) {
                mapping.isTypeCompatible = areTypesCompatible(newType, column.dataType);
                mapping.suggestedType = null;
                console.log(`✅ Type changed. Compatible: ${mapping.isTypeCompatible}`);
            }
        }

        $scope.$applyAsync();
        $timeout(recalcConnectors, 50);

        $mdToast.show(
            $mdToast.simple()
                .textContent(`Attribute type changed to ${newType}`)
                .position('top right')
                .hideDelay(2000)
        );
    };

    // ── Wire-drag system (mousedown/mousemove/mouseup live SVG wire) ───────
    // Replaces native HTML5 drag-and-drop: instead of the browser's default
    // ghost-image drag, a live bezier wire follows the cursor and snaps to
    // valid/invalid drop targets in real time, before the mouse is released.

    function _mappingContainerEl() {
        return document.querySelector('.mapping-container');
    }

    // Adaptive control-point offset so the curve never looks flat (close
    // elements) or overly loopy (far apart) — replaces the old fixed-fraction
    // (startX + (endX-startX)/3) curve math from drawConnections().
    function _buildPath(x1, y1, x2, y2) {
        const cp = Math.max(Math.abs(x2 - x1) * 0.45, 50);
        return `M ${x1.toFixed(1)} ${y1.toFixed(1)} C ${(x1 + cp).toFixed(1)} ${y1.toFixed(1)}, ${(x2 - cp).toFixed(1)} ${y2.toFixed(1)}, ${x2.toFixed(1)} ${y2.toFixed(1)}`;
    }

    // An attribute is only an INVALID drop target if it's already mapped —
    // type mismatch is allowed (shown via orange/red connector + toast on
    // release), matching the existing onDrop/zone-drop behavior. Do not
    // import the Biz Event mapper's stricter type-blocking semantics here.
    function _validateConnection(column, attribute) {
        if ($scope.isAttributeMapped(attribute)) {
            return { valid: false, reason: 'This attribute is already mapped. Unmap it first.' };
        }
        return { valid: true };
    }

    function _computeInvalidMap(column) {
        $scope._connectingInvalidMap = {};
        $scope.resourceAttributes.forEach(function (attr) {
            if (!_validateConnection(column, attr).valid) {
                $scope._connectingInvalidMap[attr.id] = true;
            }
        });
    }

    $scope.isAttributeInvalidDuringDrag = function (attribute) {
        return !!($scope.connecting && $scope._connectingInvalidMap[attribute.id]);
    };

    // mousedown on a column-item — starts the live wire
    $scope.startConnect = function (column, $event) {
        if ($scope.isColumnMapped(column)) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('This column is already mapped.')
                    .position('top right')
                    .hideDelay(1800)
            );
            return;
        }
        $event.preventDefault();

        const container = _mappingContainerEl();
        if (!container) return;
        const containerRect = container.getBoundingClientRect();

        const srcEl = document.querySelector(`[data-column="${column.columnName}"]`);
        const r = srcEl ? srcEl.getBoundingClientRect() : { right: $event.clientX, top: $event.clientY, height: 0 };
        const startX = r.right - containerRect.left;
        const startY = r.top + r.height / 2 - containerRect.top;

        $scope.connecting = { column: column, startX: startX, startY: startY };
        $scope.connectingTarget = null;
        $scope.connectingValid = null;
        $scope.connectingDropZoneIndex = null;
        $scope._liveWire = { d: _buildPath(startX, startY, startX + 30, startY), x1: startX, y1: startY, x2: startX + 30, y2: startY, snapped: false };

        _computeInvalidMap(column);

        document.addEventListener('mousemove', _onConnectMove);
        document.addEventListener('mouseup', _onConnectUp);
    };

    function _onConnectMove(e) {
        if (!$scope.connecting) return;
        const container = _mappingContainerEl();
        if (!container) return;
        const containerRect = container.getBoundingClientRect();
        let mx = e.clientX - containerRect.left;
        let my = e.clientY - containerRect.top;

        const el = document.elementFromPoint(e.clientX, e.clientY);
        let newTarget = null;
        let newDropIndex = null;
        let walk = el;
        while (walk) {
            if (walk.classList && walk.classList.contains('drop-zone-indicator')) {
                const idxAttr = walk.getAttribute('data-drop-index');
                if (idxAttr !== null) { newDropIndex = parseInt(idxAttr, 10); break; }
            }
            if (walk.getAttribute) {
                const attrId = walk.getAttribute('data-attribute');
                if (attrId) {
                    // The drop-zone-indicator between two attribute cards is only
                    // 16-24px tall — far narrower than the attribute cards flanking
                    // it — so requiring the cursor to land exactly on that sliver
                    // made "drop between two attributes" effectively impossible
                    // outside the (comparatively spacious) very top of the list.
                    // Mirror the old native-drag EDGE_RATIO behavior instead: the
                    // top/bottom edge of the *attribute card itself* counts as
                    // hovering the adjacent gap, same as before this was ported.
                    var attrIdx = $scope.resourceAttributes.findIndex(function (a) { return a.id === attrId; });
                    var attrRect = walk.getBoundingClientRect();
                    var edge = attrRect.height * 0.3;
                    var yInCard = e.clientY - attrRect.top;
                    if (attrIdx >= 0 && yInCard < edge) {
                        newDropIndex = attrIdx;
                    } else if (attrIdx >= 0 && yInCard > attrRect.height - edge) {
                        newDropIndex = attrIdx + 1;
                    } else {
                        newTarget = $scope.resourceAttributes[attrIdx] || null;
                    }
                    break;
                }
            }
            if (walk.classList && walk.classList.contains('mapping-container')) break;
            walk = walk.parentElement;
        }

        $scope.connectingTarget = newDropIndex !== null ? null : newTarget;
        $scope.connectingDropZoneIndex = newDropIndex;
        $scope.connectingValid = newTarget ? _validateConnection($scope.connecting.column, newTarget).valid : null;

        // Snap the wire endpoint to the hovered element's rect, not the raw mouse position
        const snapEl = newDropIndex !== null
            ? document.querySelector(`.drop-zone-indicator[data-drop-index="${newDropIndex}"]`)
            : (newTarget ? document.querySelector(`[data-attribute="${newTarget.id}"]`) : null);
        if (snapEl) {
            const sr = snapEl.getBoundingClientRect();
            mx = sr.left - containerRect.left;
            my = sr.top + sr.height / 2 - containerRect.top;
        }

        $scope._liveWire = {
            d: _buildPath($scope.connecting.startX, $scope.connecting.startY, mx, my),
            x1: $scope.connecting.startX, y1: $scope.connecting.startY, x2: mx, y2: my,
            snapped: !!(newTarget || newDropIndex !== null),
            invalid: $scope.connectingValid === false
        };
        $scope.$apply();
    }

    function _onConnectUp() {
        document.removeEventListener('mousemove', _onConnectMove);
        document.removeEventListener('mouseup', _onConnectUp);

        const column = $scope.connecting && $scope.connecting.column;
        const target = $scope.connectingTarget;
        const dropIndex = $scope.connectingDropZoneIndex;

        $scope.connecting = null;
        $scope.connectingTarget = null;
        $scope.connectingDropZoneIndex = null;
        $scope.connectingValid = null;
        $scope._liveWire = null;
        $scope._connectingInvalidMap = {};

        if (column && typeof dropIndex === 'number') {
            // Dropped on a gap between attribute rows — create a new attribute from this column
            if ($scope.isColumnMapped(column)) {
                $mdToast.show($mdToast.simple().textContent('This column is already mapped.').position('top right').hideDelay(1800));
            } else if (attributeNameExists(column.columnName)) {
                $mdToast.show($mdToast.simple().textContent(`Attribute "${column.columnName}" already exists`).position('top right').hideDelay(2500));
            } else {
                const newAttribute = $scope.createAttributeFromColumn(column, dropIndex);
                if (newAttribute) {
                    $mdToast.show($mdToast.simple().textContent(`✨ Attribute "${column.columnName}" created`).position('top right').hideDelay(2500));
                    // Inserting a new attribute also collapses the drop-zone indicator
                    // back down via its own CSS transition (.drop-zone-indicator's
                    // `transition: all 0.25s`) as the list reflows around the new card.
                    // The shared 40ms recalc below runs mid-animation and captures the
                    // wrong (still-settling) position for the new card, leaving the
                    // connector visibly kinked at the source with nothing to correct it
                    // afterward. Recalculate again once that transition has finished.
                    $timeout(recalcConnectors, 320);
                }
            }
        } else if (column && target) {
            const v = _validateConnection(column, target);
            if (!v.valid) {
                $mdToast.show($mdToast.simple().textContent(v.reason).position('top right').hideDelay(2200));
            } else {
                _createOrUpdateMapping(column, target);
            }
        }
        // else: dropped on empty space — silent cancel

        $scope.$apply();
        $timeout(recalcConnectors, 40);
    }

    // Creates/updates a mapping for (column → attribute) — extracted verbatim
    // from the old onDrop handler's body so the logic is unchanged.
    function _createOrUpdateMapping(column, attribute) {
        const isCompatible = areTypesCompatible(attribute.dataType, column.dataType);
        const suggestedType = isCompatible ? null : suggestTypeForColumn(column.dataType);

        const existingMapping = $scope.mappings.find(m => m.attributeId === attribute.id);

        if (existingMapping) {
            const oldColumn = $scope.tableColumns.find(c => c.columnName === existingMapping.columnName);
            if (oldColumn) {
                oldColumn.mapped = false;
                oldColumn.mappedTo = null;
            }
            existingMapping.columnName = column.columnName;
            existingMapping.isTypeCompatible = isCompatible;
            existingMapping.suggestedType = suggestedType;
        } else {
            const existingColMapping = $scope.mappings.find(m => m.columnName === column.columnName);
            if (existingColMapping) {
                const oldAttr = $scope.resourceAttributes.find(a => a.id === existingColMapping.attributeId);
                if (oldAttr) {
                    oldAttr.mapped = false;
                    oldAttr.mappedFrom = null;
                }
                const idx = $scope.mappings.indexOf(existingColMapping);
                $scope.mappings.splice(idx, 1);
            }

            $scope.mappings.push({
                attributeName: attribute.name,
                attributeId: attribute.id,
                columnName: column.columnName,
                isTypeCompatible: isCompatible,
                suggestedType: suggestedType
            });
        }

        column.mapped = true;
        column.mappedTo = attribute.name;
        attribute.mapped = true;
        attribute.mappedFrom = column.columnName;

        if (!isCompatible) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent(`⚠️ Type mismatch: ${column.dataType} → ${attribute.dataType}`)
                    .position('top right')
                    .hideDelay(3000)
            );
        }
    }

    // Rebuilds $scope._connectors reactively from $scope.mappings (a plain
    // state array rendered via ng-repeat, not imperative DOM/SVG creation) —
    // replaces drawConnections().
    function recalcConnectors() {
        const container = _mappingContainerEl();
        if (!container) { $scope._connectors = []; return; }
        const containerRect = container.getBoundingClientRect();
        $scope._connectors = $scope.mappings.map(function (m) {
            const colEl = document.querySelector(`[data-column="${m.columnName}"]`);
            const attrEl = document.querySelector(`[data-attribute="${m.attributeId}"]`);
            if (!colEl || !attrEl) return null;
            // Skip connectors to either endpoint hidden by the search filter
            // (ng-hide) — a visible offsetParent means the element and all
            // its ancestors are rendered (not display:none).
            if (colEl.offsetParent === null || attrEl.offsetParent === null) return null;
            const cr = colEl.getBoundingClientRect();
            const ar = attrEl.getBoundingClientRect();
            const x1 = cr.right - containerRect.left;
            const y1 = cr.top + cr.height / 2 - containerRect.top;
            const x2 = ar.left - containerRect.left;
            const y2 = ar.top + ar.height / 2 - containerRect.top;
            return {
                id: m.attributeId + '|' + m.columnName,
                columnName: m.columnName,
                attributeId: m.attributeId,
                d: _buildPath(x1, y1, x2, y2),
                x1: x1, y1: y1, x2: x2, y2: y2, cx: (x1 + x2) / 2, cy: (y1 + y2) / 2,
                isTypeCompatible: m.isTypeCompatible
            };
        }).filter(Boolean);
    }

    $scope.$watchCollection('mappings', function () {
        $timeout(recalcConnectors, 50);
    });

    // Briefly flags an element with .nav-highlight so CSS can flash it, then
    // un-flags it after a delay. Re-entrant: clicking the same connector/item
    // again restarts the timer instead of stacking multiple removals.
    function _flashElement(el) {
        if (!el) return;
        el.classList.add('nav-highlight');
        if (el._navHighlightTimeout) { $timeout.cancel(el._navHighlightTimeout); }
        el._navHighlightTimeout = $timeout(function () {
            el.classList.remove('nav-highlight');
            el._navHighlightTimeout = null;
        }, 1800);
    }

    // Scrolls both sides of a mapping into view and flashes them — shared by
    // clicking the connector, the mapped column, or the mapped attribute, so
    // all three entry points behave identically.
    function _scrollAndHighlightMapping(columnName, attributeId) {
        const colEl = document.querySelector(`[data-column="${columnName}"]`);
        if (colEl) {
            colEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            _flashElement(colEl);
        }

        const attrEl = document.querySelector(`[data-attribute="${attributeId}"]`);
        if (attrEl) {
            attrEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            _flashElement(attrEl);
        }
    }

    // Click on a connector — same "scroll + highlight both ends" behavior as
    // clicking either the mapped column or the mapped attribute directly.
    $scope.navigateToConnector = function (connector) {
        _scrollAndHighlightMapping(connector.columnName, connector.attributeId);
    };

    // Angular Material's flex="51" sizes each panel off its own content
    // (max-content), not a fixed 51% of the row — so hiding items via the
    // search filter shrinks a panel down to whatever's still visible.
    // Snapshot the width Angular Material computed for the initial,
    // everything-visible render and pin it inline so later ng-hide churn
    // from search can no longer resize the panel.
    function lockPanelWidths() {
        [document.querySelector('.columns-panel'), document.querySelector('.attributes-panel')]
            .forEach(function (panel) {
                if (!panel) return;
                const width = panel.getBoundingClientRect().width;
                if (width > 0) {
                    panel.style.flex = '0 0 ' + width + 'px';
                    panel.style.width = width + 'px';
                }
            });
    }

    function setupScrollListeners() {
        $timeout(function () {
            const columnPanel = document.querySelector('.columns-panel .panel-content');
            const attributePanel = document.querySelector('.attributes-panel .panel-content');

            let ticking = false;

            const onScroll = function () {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        // Native scroll event, outside Angular's digest — recalcConnectors()
                        // only updates the _connectors array in memory unless we ask Angular
                        // to re-render, same as _onConnectMove's $apply() during the live drag.
                        recalcConnectors();
                        $scope.$apply();
                        ticking = false;
                    });
                    ticking = true;
                }
            };

            if (columnPanel) {
                columnPanel.addEventListener('scroll', onScroll);
                columnPanel._scrollHandler = onScroll;
                console.log('✅ Scroll listener added to column panel');
            }

            if (attributePanel) {
                attributePanel.addEventListener('scroll', onScroll);
                attributePanel._scrollHandler = onScroll;
                console.log('✅ Scroll listener added to attribute panel');
            }

            console.log('✅ Scroll listeners setup complete');
        }, 100);
    }

    // ============================================
    // Ordenar listas alfabéticamente (ascendente)
    // ============================================
    function sortByKeyAscending(arr, key) {
        arr.sort(function (a, b) {
            return (a[key] || '').toLowerCase().localeCompare((b[key] || '').toLowerCase());
        });
    }

    // ============================================
    // Cargar datos iniciales
    // ============================================
    function loadData() {
        $scope.loading = true;

        const resourceType = (templateInstance.templateConfig.resource_types || []).find(rt => rt.id === resourceTypeId);

        if (!resourceType) {
            throw new Error('Resource type not found in template');
        }

        $scope.resourceTypeName = resourceType.name || resourceTypeId;

        const attributes = (templateInstance.templateConfig.attribute_types || []).filter(attr =>
            attr.resource_id === resourceTypeId
        );

        function toBool(v) {
            return v === true || v === 'true' || v === 1 || v === '1';
        }

        $scope.resourceAttributes = attributes.map(attr => ({
            id: attr.id,
            name: attr.name,
            dataType: attr.scalar_attribute_type || attr.dataType || attr.type || 'STRING',
            originalDataType: null,

            isPrimaryKey: toBool(attr.isPrimaryKey),
            isRequired: toBool(attr.required || attr.isRequired),

            // ✅ FIX: mantener flags RN/RD
            isResourceNameField: toBool(attr.isResourceNameField || attr.is_resource_name_field),
            isResourceDescriptionField: toBool(attr.isResourceDescriptionField || attr.is_resource_description_field),

            mapped: false,
            mappedFrom: null,
            typeChanged: false,
            columnMetadataName: attr.column_metadata_name || null,
            description: attr.description || null,
            enumValues: attr.enum_values || attr.enumValues || null
        }));

        sortByKeyAscending($scope.resourceAttributes, 'name');

        console.log('✅ Resource attributes loaded:', $scope.resourceAttributes.length);
        $scope.resourceAttributes.forEach(attr => {
            console.log(`  - ${attr.name}: ${attr.dataType}${attr.columnMetadataName ? ' → ' + attr.columnMetadataName : ''}`);
        });

        const columnsPromise = DatasourceService.getAttributes(datasourceId, schema, tableName)
            .then(columns => {
                $scope.tableColumns = columns.map(col => ({
                    columnName: col.columnName,
                    dataType: col.dataType,
                    columnSize: col.columnSize,
                    isPrimaryKey: col.isPrimaryKey || false,
                    isNullable: col.isNullable !== false,
                    mapped: false,
                    mappedTo: null
                }));
                sortByKeyAscending($scope.tableColumns, 'columnName');
                console.log('✅ Table columns loaded:', $scope.tableColumns.length);
            })
            .catch(err => {
                console.error('❌ Error loading table columns:', err);
                dialogService.showErrorDialog(
                    'Error Loading Columns',
                    'Failed to load table columns. ' + (err.data && err.data.message ? err.data.message : err.message || 'Unknown error')
                );
                $scope.tableColumns = [];
            });

        Promise.all([columnsPromise])
            .finally(() => {
                $scope.loading = false;
                $scope.$apply();

                if ($scope.mode === 'edit') {
                    console.log('📂 Mode is EDIT - initializing existing mappings...');

                    $timeout(() => {
                        initializeExistingMappings();

                        $timeout(() => {
                            recalcConnectors();
                            setupScrollListeners();
                            lockPanelWidths();
                        }, 150);
                    }, 100);
                } else {
                    console.log('🆕 Mode is CREATE - no existing mappings to load');
                    $timeout(() => {
                        recalcConnectors();
                        setupScrollListeners();
                        lockPanelWidths();
                    }, 300);
                }
            });
    }


    // (Old onDragStart/onDragEnd/onDragOver/onDragLeave/onDrop removed —
    // replaced by the startConnect/_onConnectMove/_onConnectUp wire-drag
    // system and _createOrUpdateMapping above.)

    $scope.isColumnMapped = function (column) {
        return $scope.mappings.some(m => m.columnName === column.columnName);
    };

    $scope.isAttributeMapped = function (attribute) {
        return $scope.mappings.some(m => m.attributeId === attribute.id);
    };

    $scope.hasTypeIncompatibility = function (attribute) {
        const mapping = $scope.mappings.find(m => m.attributeId === attribute.id);
        return mapping && !mapping.isTypeCompatible;
    };

    $scope.hasAnyTypeIncompatibility = function () {
        return $scope.mappings.some(m => !m.isTypeCompatible);
    };

    // ============================================
    // Detectar Cambios (para habilitar botón Confirm)
    // ============================================
    $scope.hasChanges = function () {
        // En modo CREATE: permitir si hay al menos 1 mapping
        if ($scope.mode === 'create') {
            return $scope.mappings.length > 0;
        }

        // En modo EDIT: detectar cambios vs estado inicial
        if ($scope.initialMappings.length === 0 && $scope.mappings.length === 0) {
            return false; // No había mappings y no se crearon
        }

        // Si la cantidad cambió, hay cambios
        if ($scope.mappings.length !== $scope.initialMappings.length) {
            return true;
        }

        // Verificar si algún mapping del estado inicial fue eliminado
        for (let i = 0; i < $scope.initialMappings.length; i++) {
            const initialMapping = $scope.initialMappings[i];
            const exists = $scope.mappings.some(m =>
                m.attributeId === initialMapping.attributeId &&
                m.columnName === initialMapping.columnName
            );

            if (!exists) {
                return true; // Mapping eliminado
            }
        }

        // Verificar si hay mappings nuevos que no existían
        for (let i = 0; i < $scope.mappings.length; i++) {
            const currentMapping = $scope.mappings[i];
            const existed = $scope.initialMappings.some(m =>
                m.attributeId === currentMapping.attributeId &&
                m.columnName === currentMapping.columnName
            );

            if (!existed) {
                return true; // Mapping nuevo
            }
        }

        return false; // No hay cambios
    };

    $scope.getMappingForAttribute = function (attribute) {
        return $scope.mappings.find(m => m.attributeId === attribute.id);
    };

    $scope.getMappedColumn = function (attribute) {
        const mapping = $scope.mappings.find(m => m.attributeId === attribute.id);
        return mapping ? mapping.columnName : null;
    };

    $scope.removeMapping = function (mapping) {
        const index = $scope.mappings.indexOf(mapping);
        if (index === -1) return;

        const column = $scope.tableColumns.find(c => c.columnName === mapping.columnName);
        if (column) {
            column.mapped = false;
            column.mappedTo = null;
        }

        const attribute = $scope.resourceAttributes.find(a => a.id === mapping.attributeId);
        if (attribute) {
            attribute.mapped = false;
            attribute.mappedFrom = null;

            if (attribute.typeChanged && attribute.originalDataType) {
                console.log(`🔄 Undoing type mutation: ${attribute.name} from ${attribute.dataType} back to ${attribute.originalDataType}`);
                attribute.dataType = attribute.originalDataType;
                attribute.typeChanged = false;
                attribute.originalDataType = null;
            }
        }

        $scope.mappings.splice(index, 1);
        console.log('🗑️ Mapping removed:', mapping.columnName, '→', mapping.attributeName);

        $scope.$applyAsync();
        $timeout(recalcConnectors, 50);
    };

    $scope.removeMappingByAttributeId = function (attributeId, $event) {
        if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }

        const mapping = $scope.mappings.find(m => m.attributeId === attributeId);
        if (!mapping) {
            console.warn('⚠️ No mapping found for attribute:', attributeId);
            return;
        }

        const attributeIndex = $scope.resourceAttributes.findIndex(a => a.id === attributeId);
        const attribute = attributeIndex >= 0 ? $scope.resourceAttributes[attributeIndex] : null;

        const hadTypeMutation = attribute && attribute.typeChanged;

        const shouldDeleteAttribute =
            attribute && (attribute.createdFromImport === true || attribute.isNewlyCreated === true);

        console.log('🗑️ Removing mapping for attribute:', attributeId);
        $scope.removeMapping(mapping);

        if (shouldDeleteAttribute && attributeIndex >= 0) {
            console.log('🧹 Deleting created attribute after unmap:', attribute.name);

            $scope.resourceAttributes.splice(attributeIndex, 1);

            $timeout(recalcConnectors, 80);

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Mapping removed and attribute deleted')
                    .position('top right')
                    .hideDelay(2200)
            );

            return;
        }

        if (hadTypeMutation) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Mapping removed and type mutation undone')
                    .position('top right')
                    .hideDelay(2500)
            );
        } else {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Mapping removed')
                    .position('top right')
                    .hideDelay(1500)
            );
        }
    };

    function normalizeForComparison(str) {
        if (!str) return '';
        return str
            .toLowerCase()
            .replace(/[_\-\s]+/g, '')
            .trim();
    }

    function getWords(str) {
        if (!str) return [];
        return str
            .toLowerCase()
            .split(/[_\-\s]+/)
            .filter(word => word.length > 2);
    }

    function calculateMatchScore(columnName, attributeName) {
        const normCol = normalizeForComparison(columnName);
        const normAttr = normalizeForComparison(attributeName);

        if (normCol === normAttr) {
            console.log(`  ✅ Exact match: "${columnName}" ≈ "${attributeName}" (score: 100)`);
            return 100;
        }

        if (normCol.includes(normAttr) || normAttr.includes(normCol)) {
            const score = 90;
            console.log(`  ✅ Contains match: "${columnName}" ≈ "${attributeName}" (score: ${score})`);
            return score;
        }

        const colWords = getWords(columnName);
        const attrWords = getWords(attributeName);

        if (colWords.length === 0 || attrWords.length === 0) {
            return 0;
        }

        const matchingWords = colWords.filter(colWord =>
            attrWords.some(attrWord => {
                if (colWord === attrWord) return true;
                if (colWord.includes(attrWord) || attrWord.includes(colWord)) return true;
                return false;
            })
        );

        if (matchingWords.length > 0) {
            const totalWords = Math.max(colWords.length, attrWords.length);
            const matchRatio = matchingWords.length / totalWords;
            const score = Math.round(matchRatio * 80);

            console.log(`  ✅ Word match: "${columnName}" ≈ "${attributeName}" (${matchingWords.length}/${totalWords} words, score: ${score})`);
            return score;
        }

        return 0;
    }

    function findBestColumnMatch(attribute, availableColumns) {
        let bestMatch = null;
        let bestScore = 0;

        availableColumns.forEach(column => {
            const score = calculateMatchScore(column.columnName, attribute.name);

            if (score > bestScore) {
                bestScore = score;
                bestMatch = column;
            }
        });

        return { column: bestMatch, score: bestScore };
    }

    $scope.autoMap = function () {
        console.log('🤖 Starting intelligent auto-mapping...');

        let mappedCount = 0;
        const MIN_MATCH_SCORE = 50;

        const unmappedAttributes = $scope.resourceAttributes.filter(attr => !attr.mapped);
        const unmappedColumns = $scope.tableColumns.filter(col => !col.mapped);

        console.log(`📊 Unmapped attributes: ${unmappedAttributes.length}`);
        console.log(`📊 Unmapped columns: ${unmappedColumns.length}`);

        const potentialMatches = [];

        unmappedAttributes.forEach(attr => {
            const { column, score } = findBestColumnMatch(attr, unmappedColumns);

            if (column && score >= MIN_MATCH_SCORE) {
                potentialMatches.push({
                    attribute: attr,
                    column: column,
                    score: score
                });
            }
        });

        potentialMatches.sort((a, b) => b.score - a.score);

        console.log(`🎯 Found ${potentialMatches.length} potential matches (score >= ${MIN_MATCH_SCORE})`);

        const usedColumns = new Set();
        const usedAttributes = new Set();

        potentialMatches.forEach(match => {
            if (usedColumns.has(match.column.columnName) || usedAttributes.has(match.attribute.id)) {
                return;
            }

            const attr = match.attribute;
            const column = match.column;

            const isCompatible = areTypesCompatible(attr.dataType, column.dataType);
            const suggestedType = isCompatible ? null : suggestTypeForColumn(column.dataType);

            $scope.mappings.push({
                attributeName: attr.name,
                attributeId: attr.id,
                columnName: column.columnName,
                isTypeCompatible: isCompatible,
                suggestedType: suggestedType
            });

            column.mapped = true;
            column.mappedTo = attr.name;
            attr.mapped = true;
            attr.mappedFrom = column.columnName;

            usedColumns.add(column.columnName);
            usedAttributes.add(attr.id);

            mappedCount++;

            const compatibilityIcon = isCompatible ? '✅' : '⚠️';
            console.log(`🔗 Mapped (score: ${match.score}): "${column.columnName}" → "${attr.name}" ${compatibilityIcon}`);
        });

        const message = mappedCount > 0
            ? `Auto-mapped ${mappedCount} column${mappedCount !== 1 ? 's' : ''} successfully`
            : 'No automatic mappings found. Please map columns manually.';

        $mdToast.show(
            $mdToast.simple()
                .textContent(message)
                .position('top right')
                .hideDelay(3000)
        );

        console.log(`✅ Auto-mapping completed: ${mappedCount} mappings created`);

        $timeout(recalcConnectors, 100);
    };

    $scope.clearAll = function () {
        $scope.mappings = [];

        let mutationsUndone = 0;

        $scope.tableColumns.forEach(col => {
            col.mapped = false;
            col.mappedTo = null;
        });

        $scope.resourceAttributes.forEach(attr => {
            attr.mapped = false;
            attr.mappedFrom = null;

            if (attr.typeChanged && attr.originalDataType) {
                console.log(`🔄 Undoing type mutation for ${attr.name}: ${attr.dataType} → ${attr.originalDataType}`);
                attr.dataType = attr.originalDataType;
                attr.typeChanged = false;
                attr.originalDataType = null;
                mutationsUndone++;
            }
        });

        recalcConnectors();
        console.log('🗑️ All mappings cleared');

        const message = mutationsUndone > 0
            ? `All mappings cleared and ${mutationsUndone} type mutation${mutationsUndone > 1 ? 's' : ''} undone`
            : 'All mappings cleared';

        $mdToast.show(
            $mdToast.simple()
                .textContent(message)
                .position('top right')
                .hideDelay(2000)
        );
    };

    $scope.cancel = function () {
        if (!$scope.hasChanges()) { $mdDialog.cancel(); return; }
        dialogService.showDecisionDialog(
            'Discard Changes',
            'You have unsaved mapping changes. Are you sure you want to close without saving?'
        ).then(function (decision) {
            if (decision === 'proceed') { $mdDialog.cancel(); }
        });
    };

    $scope.confirmMapping = function () {
        // En modo CREATE: requiere al menos 1 mapping
        if ($scope.mode === 'create' && $scope.mappings.length === 0) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Please map at least one column')
                    .position('top right')
                    .hideDelay(2000)
            );
            return;
        }

        const unmappedAttributeIds = [];
        const newMappings = [];

        if ($scope.mode === 'edit') {
            // ✅ Detectar mappings NUEVOS (no existían antes)
            $scope.mappings.forEach(currentMapping => {
                const existedBefore = $scope.initialMappings.some(m =>
                    m.attributeId === currentMapping.attributeId &&
                    m.columnName === currentMapping.columnName
                );

                if (!existedBefore) {
                    const attribute = $scope.resourceAttributes.find(a => a.id === currentMapping.attributeId);
                    newMappings.push({
                        attributeId: currentMapping.attributeId,
                        attributeName: currentMapping.attributeName,
                        columnName: currentMapping.columnName,
                        isNewAttribute: attribute ? attribute.createdFromImport : false,
                        isTypeCompatible: currentMapping.isTypeCompatible,
                        suggestedType: currentMapping.suggestedType
                    });
                    console.log(`🆕 New mapping detected: ${currentMapping.columnName} → ${currentMapping.attributeName}`);
                }
            });

            // ✅ Detectar atributos que fueron DESMAPEADOS
            $scope.initialMappings.forEach(initialMapping => {
                const stillMapped = $scope.mappings.some(m => m.attributeId === initialMapping.attributeId);

                if (!stillMapped) {
                    unmappedAttributeIds.push(initialMapping.attributeId);
                    console.log(`🗑️ Attribute unmapped: ${initialMapping.attributeId} (was mapped to ${initialMapping.columnName})`);
                }
            });

            if (unmappedAttributeIds.length > 0) {
                console.log(`📋 Total unmapped attributes: ${unmappedAttributeIds.length}`);
            }

            if (newMappings.length > 0) {
                console.log(`📋 Total new mappings: ${newMappings.length}`);
            }
        }

        console.log('✅ Confirming mappings:', $scope.mappings);

        const result = {
            mode: $scope.mode, // ✅ NUEVO: Incluir el modo

            // Todos los mappings actuales
            mappings: $scope.mappings.map(m => ({
                attributeId: m.attributeId,
                attributeName: m.attributeName,
                columnName: m.columnName,
                isTypeCompatible: m.isTypeCompatible,
                suggestedType: m.suggestedType
            })),

            // ✅ NUEVO: Mappings que se agregaron en esta sesión de edición
            newMappings: newMappings,

            // Atributos cuyo tipo fue modificado
            modifiedAttributes: $scope.resourceAttributes
                .filter(attr => attr.typeChanged)
                .map(attr => ({
                    id: attr.id,
                    name: attr.name,
                    originalType: attr.originalDataType,
                    newType: attr.dataType
                })),

            // Atributos que fueron desmapeados
            unmappedAttributes: unmappedAttributeIds,

            // Atributos completamente nuevos (creados desde columnas)
            createdAttributes: $scope.resourceAttributes
                .filter(attr => attr.createdFromImport)
                .map(attr => ({
                    id: attr.id,
                    name: attr.name,
                    dataType: attr.dataType,
                    isPrimaryKey: attr.isPrimaryKey,
                    isRequired: attr.isRequired,
                    description: attr.description || null, // ✅ NUEVO
                    enumValues: attr.enumValues || null, // ✅ NUEVO
                    columnMetadataName: attr.mappedFrom // ✅ NUEVO: el column name para el mapeo
                }))
        };

        console.log('📦 Map Dialog result:', result);
        console.log('📦 Result breakdown:');
        console.log(`  - Total mappings: ${result.mappings.length}`);
        console.log(`  - New mappings (edit): ${result.newMappings.length}`);
        console.log(`  - Modified types: ${result.modifiedAttributes.length}`);
        console.log(`  - Unmapped: ${result.unmappedAttributes.length}`);
        console.log(`  - Created attributes: ${result.createdAttributes.length}`);

        $mdDialog.hide(result);
    };

    $scope.$on('$destroy', function () {
        angular.element(window).off('resize');

        document.removeEventListener('mousemove', _onConnectMove);
        document.removeEventListener('mouseup', _onConnectUp);

        const columnPanel = document.querySelector('.columns-panel .panel-content');
        const attributePanel = document.querySelector('.attributes-panel .panel-content');

        if (columnPanel && columnPanel._scrollHandler) {
            columnPanel.removeEventListener('scroll', columnPanel._scrollHandler);
        }

        if (attributePanel && attributePanel._scrollHandler) {
            attributePanel.removeEventListener('scroll', attributePanel._scrollHandler);
        }
    });

    $scope.navigateToMappedAttribute = function (column) {
        const mapping = $scope.mappings.find(m => m.columnName === column.columnName);
        if (mapping) {
            _scrollAndHighlightMapping(mapping.columnName, mapping.attributeId);
        }
    };

    $scope.navigateToMappedColumn = function (attribute) {
        const mapping = $scope.mappings.find(m => m.attributeId === attribute.id);
        if (mapping) {
            _scrollAndHighlightMapping(mapping.columnName, mapping.attributeId);
        }
    };

    // ── Search (UI-only) ────────────────────────────────────────────────────
    // Case-insensitive, partial (substring) match. This never filters the
    // list — every column/attribute stays visible so mapping context isn't
    // lost — it only highlights matches and scrolls the first one into view.
    $scope.isColumnSearchMatch = function (column) {
        if (!$scope.search.column) return false;
        const term = $scope.search.column.trim().toLowerCase();
        if (!term) return false;
        return column.columnName.toLowerCase().indexOf(term) !== -1;
    };

    $scope.isAttributeSearchMatch = function (attribute) {
        if (!$scope.search.attribute) return false;
        const term = $scope.search.attribute.trim().toLowerCase();
        if (!term) return false;
        return attribute.name.toLowerCase().indexOf(term) !== -1;
    };

    $scope.onColumnSearchChange = function () {
        const term = ($scope.search.column || '').trim().toLowerCase();
        if (!term) return;
        const match = $scope.tableColumns.find(c => c.columnName.toLowerCase().indexOf(term) !== -1);
        if (!match) return;
        const el = document.querySelector(`[data-column="${match.columnName}"]`);
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };

    $scope.onAttributeSearchChange = function () {
        const term = ($scope.search.attribute || '').trim().toLowerCase();
        if (!term) return;
        const match = $scope.resourceAttributes.find(a => a.name.toLowerCase().indexOf(term) !== -1);
        if (!match) return;
        const el = document.querySelector(`[data-attribute="${match.id}"]`);
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };

    loadData();

    $scope.getEnumRowIndices = function (enumValuesLength) {
        if (!enumValuesLength || enumValuesLength === 0) {
            return [];
        }
        const numRows = Math.ceil(enumValuesLength / 2);
        const indices = [];
        for (let i = 0; i < numRows; i++) {
            indices.push(i);
        }
        return indices;
    };
});